import XLSX from 'xlsx';
import moment from 'moment';
import {message} from 'antd';


// 加法
window.Number.prototype.add = function (arg) {
  var r1, r2, m;
  try {
    r1 = this.toString().split(".")[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg.toString().split(".")[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  return (this * m + arg * m) / m
};

//减法
window.Number.prototype.sub = function (arg) {
  return this.add(-arg);
};

//乘法
window.Number.prototype.mul = function (arg) {
  var m = 0,
    s1 = this.toString(),
    s2 = arg.toString();
  try {
    m += s1.split(".")[1].length
  } catch (e) {
  }
  try {
    m += s2.split(".")[1].length
  } catch (e) {
  }
  return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
};

//除法
window.Number.prototype.div = function (arg) {
  var t1 = 0,
    t2 = 0,
    r1, r2;
  try {
    t1 = this.toString().split(".")[1].length
  } catch (e) {
  }
  try {
    t2 = arg.toString().split(".")[1].length
  } catch (e) {
  }
  r1 = Number(this.toString().replace(".", ""))
  r2 = Number(arg.toString().replace(".", ""))
  // console.log(t1, t2, r1, r2);
  return (r1 / r2).mul( Math.pow(10, t2 - t1) );
};

/**
 * 清除数组中的 falsy 元素
 * @param {Array} arr
 */
function compact(arr) {
  let result = [];
  if (arr == null) {
    return result;
  }
  let index = 0;
  for (const value of arr) {
    if (value) {
      result[index] = value;
      index++
    }
  }
  return result;
}

function recursion(that, object) {
  for (let attr in object) {
    if (typeof object[attr] === 'object') {
      for (let inner_attr in object[attr]) {
        if (typeof that[attr][inner_attr] === 'object') {
          recursion(that[attr], object[attr]);
        } else {
          if (Object.keys(that[attr]).includes(inner_attr)) {
            that[attr][inner_attr] = object[attr][inner_attr];
          }
        }
        //TODO: 递归处理，万一 data[attr][inner_attr] 还是个对象
      }
    } else if (Array.isArray(that[attr])) {
      object[attr].map((i, n) =>
        that[attr].push(i)
      );
    } else {
      if (Object.keys(that).includes(attr)) {
        that[attr] = object[attr];
      }
    }
  }
}


function exportFile({
  file_name,
  file_data,
  file_column
}) {

  let aoa_to_sheet_columns = [];
  let aoa_to_sheet_data = [];

  file_column.map(i => {
    return aoa_to_sheet_columns.push(i.title);
  });

  aoa_to_sheet_data.push(aoa_to_sheet_columns);

  file_data.map(i => {
    let _item = [];
    file_column.map(_i => {
      if (_i.dataIndex) {
        return  _item.push(i[_i.dataIndex])
      } else if (_i.format && typeof _i.format === 'function') {
        return _item.push(_i.format(i) || '-');
      } else {
        return _item.push('-');
      }
    });
    return aoa_to_sheet_data.push(_item);
  });

  const worksheet = XLSX.utils.aoa_to_sheet(aoa_to_sheet_data);
  const new_workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(new_workbook, worksheet, "SheetJS");
  XLSX.writeFile(new_workbook, `${file_name}.xlsx`);
}


var utils = {
  init: function () {
    window.Date.prototype.format = function (fmt = "yyyy-MM-dd hh:mm:ss") {
      let o = {
        'M+': this.getMonth() + 1,
        'd+': this.getDate(),
        'H+': this.getHours(),
        'h+': this.getHours(),
        'm+': this.getMinutes(),
        's+': this.getSeconds(),
        'q+': Math.floor((this.getMonth() + 3) / 3),
        'S+': this.getMilliseconds()
      }
      if (new RegExp(`(y+)`).test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? o[k] : (('00' + o[k]).substr(('' + o[k]).length)))
        }
      }
      return fmt;
    };

    /**
     * 获取当前日期 00:00:00.000 起始时间戳
     */
    window.Date.prototype.getStartTimestamp = function () {
      let this_start_timestamp_str = `${moment(this).format("YYYY-MM-DD")} 00:00:00`;
      return Math.floor( new Date(this_start_timestamp_str).getTime() / 1000 );
    };

    /**
     * 获取当前日期 59:59:59.999 结束时间戳
     */
    window.Date.prototype.getEndTimestamp = function () {
      let this_end_timestamp_str = `${moment(this).add(1, 'days').format("YYYY-MM-DD")} 00:00:00`;
      return Math.floor( (new Date(this_end_timestamp_str).getTime() - 1) /1000 );
    };

    /**
     * 获取两个日期的月份差
     * @param {较小的日期} date1
     * @param {较大的日期} date2
     */
    window.Date.prototype.getMonthDistance = function (date1, date2) {
      let date1_str = new Date(date1).format('yyyyMMdd');
      let date2_str = new Date(date2).format('yyyyMMdd');

      let year1 = date1_str.substr(0, 4);
      let year2 = date2_str.substr(0, 4);
      let month1 = date1_str.substr(4, 2);
      let month2 = date2_str.substr(4, 2);

      let res = (year2 - year1) * 12 + (month2 - month1);
      return res;
    };

    /**
     * 判断数组是否是 super_array 的子集
     */
    window.Array.prototype.isSubArrayOf = function (super_array) {
      if (!Array.isArray(super_array)) {
        console.error("super_array is not an array");
        return undefined;
      }
      let super_array_clone = super_array.slice();
      for (let i = 0, len = this.length; i < len; i++) {
        if (super_array_clone.indexOf(this[i]) === -1) {
          return false;
        } else {
          super_array_clone.splice(super_array_clone.indexOf(this[i]), 1);
        }
      }
      return true;
    };

    /**
     * 删除数组元素
     * @param {*} ele 需要删除的数组元素
     * @param {Boolean} deep 贪婪删除（默认为 false, 只删除第一个）
     */
    window.Array.prototype.removeEle = function (ele, deep = false) {
      const remove = () => {
        let index = this.indexOf(ele);
        if (index != -1) {
          this.splice(index, 1);
          return true;
        } else {
          return false;
        }
      }

      if (deep) {
        while (remove()) {
          remove()
        }
      } else {
        remove();
      }
      return this;
    }

    /**
     * Map().map()
     */
    window.Map.prototype.map = function (fn) {
      let result = [];
      this.forEach((value, key, map) => {
        result.push(fn.call(null, value, key, map));
      });
      return result;
    },

    /**
     * 首字符大写
     */
    window.String.prototype.capitalizes = function () {
      if (!this) {
        return;
      }
      return this[0].toUpperCase() + this.substr(1);
    };

    window.Number.prototype.toPercentage = function (decimal) {
      // console.log(this, decimal);
      if (!this) {
        return;
      }
      return (this * 100) + '%';
    };

    window.Number.prototype.toPercentage2 = function () {
      if (!this) {
        return;
      }
      return (this * 100).toFixed(2) + '%';
    };

    /**
     * 格式化金额
     * 9999999.00  -> 9,999,999.00
     */
    window.Number.prototype.amountFormat = function () {
      if (isNaN(this)) {
        return '0.00';
      } else {
        return (parseFloat(this).toFixed(2) + '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
    };

    window.String.prototype.amountFormat = window.Number.prototype.amountFormat;
    /**
     * 金额显示格式化
     * @param {Number | String} amount 金额
     */
    window.FormatAmount = function (amount) {
      if (isNaN(parseFloat(amount))) {
        return '0.00'
      } else {
        return amount.amountFormat();
      }
    };
    /**
     * 把 Number 指定小数位数的数字 舍弃小数位后位数（不做四舍五入处理）
     * @param {*} count
     */
    window.Number.prototype.toFixedCustom = function (count) {
      return this.toFixed(count + 1).toString().slice(0, -1);
    };

    /**
     * 判断对象是否为空对象
     */
    window.isEmptyObject = ( obj ) => {
      if( typeof obj === 'object') {
        let key_length = Object.keys(obj).length;
        if( key_length > 0 ) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    }
  },

  /**
   *
   */
  timeSplit: function (dateTime) {
    try {
      let date = dateTime.format('yyyy-MM-dd');
      let time = dateTime.format('hh:mm:ss');
      return {
        date,
        time
      };
    } catch (e) {
      console.error(e);
    }
  },

  /**
   * 定时轮询
   */
  sleepPromise: function (sleep_time) {
    let res = {};
    res.promise = new Promise((resolve, reject) => {
      res.timer = setTimeout(() => {
        resolve('success')
      }, sleep_time)
    });
    return res;
  },

  /**
   * 倒计时
   */
  countDown: function (date) {
    let millisecond_distance = new Date(date).getTime() - new Date().getTime();
    // 一天的毫秒数
    let one_day_millisecond = 24 * 60 * 60 * 1000;
    // 一小时的毫秒数
    let one_hour_millisecond = 60 * 60 * 1000;
    // 一分钟的毫秒数
    let one_minute_millisecond = 60 * 1000;

    // millisecond_distance 所含的天数
    let temp_day = parseInt(millisecond_distance / one_day_millisecond);
    // millisecond_distance 扣除 temp_day 的毫秒数
    millisecond_distance = millisecond_distance - (temp_day * one_day_millisecond);

    let temp_hours = parseInt(millisecond_distance / one_hour_millisecond);

    millisecond_distance = millisecond_distance - (temp_hours * one_hour_millisecond);

    let temp_minutes = parseInt(millisecond_distance / one_minute_millisecond);

    return {
      day: temp_day,
      hours: temp_hours,
      minutes: temp_minutes
    }
  },
  encryptCellphone: function (cellphone, formatString) {
    if (!cellphone) {
      return;
    }
    if (formatString) {
      let formatArr = formatString.split('');
      let cellphoneArr = cellphone.split('');
      let fmt = [];
      cellphoneArr.map((i, n) => {
        if (formatArr[n] === '*') {
          fmt.push('*')
        } else {
          fmt.push(i);
        }
      });
      return fmt.join('');
    } else {
      let reg = /\d{3}(\d{4})/;
      reg.test(cellphone);
      return cellphone.replace(RegExp.$1, '****');
    }
  },
  amountInput: function (amount) {
    if (/^[0]+[0-9]+$/.test(amount) || /(^[0]+[0-9]+$)+(\.[0-9])$/.test(amount) || /\.{2}/.test(amount)) {
      return false;
    } else {
      if (
        /^(([0]{0,1})|[1-9][0-9]*)+(\.[0-9]{0,2})?$/.test(amount) || amount.length === 0
      ) {
        return true;
      }
    }
  },
  Regx: {
    // 手机号校验
    cellphone: /^1[3|4|5|9|8|7][0-9]\d{8}$/,
    // 身份证校验
    IdCard: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
    PayPassword: /^\d{6}$/
  },
  sleep: (sleep_time) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve('success')
      }, sleep_time)
    });
  },
  add(num, step) {
    // 临时放着
    /**
     * 将 加数（减数）根据 小数点 '.' 分割成数组
     * 获取运算进制 x
     * 将 加数（减数）转换为整数（被减数 * x）
     * 将 被加数（被减数）转换为相应进制的整数
     * 然后 两数做整数加减运算，获得结果整数运算结果
     */
    let step_arr = (step + '').split('.');
    let step_float_length = step_arr[1] ? step_arr[1].length : 0;

    let radix = Math.pow(10, step_float_length);

    let int_step = step * radix;

    let temp_num = num * radix;
    let num_arr = (temp_num + '').split('.');
    let int_num = parseInt(num_arr[0]);

    let temp_int_num = (int_num + int_step);

    let temp_int_result = temp_int_num;
    if (num_arr[1]) {
      temp_int_result = temp_int_result + num_arr[1];
    }
    let int_result = parseFloat(temp_int_result) / radix;
    return int_result;
  },
  /**
   * 上传之前检测图片是否符合，且体积大小不能大于 3M
   * @param {File} file 图片file 文件
   * @param {Object}} resolution_opts 合格分辨率
   */
  checkImageBeforeUpload(file, resolution_opts) {
    return new Promise((resolve, reject) => {
      if (/^image\/(png|jpg|jpeg)$/.test(file.type)) {
        if (file.size / 1024 / 1024 > 3) {
          // 图片大小不能大于 3M
          message.error(`图片大小不能大于 3M.`, 3);
          reject();
        } else {
          let reader = new FileReader(file);
          reader.readAsDataURL(file);
          reader.onload = function (e) {
            var data = e.target.result;
            let image = new Image();
            image.src = data;
            image.onload = function () {
              // console.log("width: ", image.width);
              // console.log("height: ", image.height);
              if (image.width == resolution_opts.width && image.height == resolution_opts.height) {
                resolve()
              } else {
                // 图片分辨率不符
                message.error(`图片分辨率不符合, 图片分辨率应为 ${resolution_opts.width} x ${resolution_opts.height}.`, 3);
                reject()
              }
            }
          }
        }
      } else {
        // 不是图片文件
        message.error(`请上传图片格式为 png 或 jpg 的图片文件.`, 3)
        reject();
      }
    })
  }
};

utils.init();

export {
  compact,
  recursion,
  exportFile
};
export default utils;



// WEBPACK FOOTER //
// ./src/Utils/index.js